import React, {useEffect} from "react";
import './AnalizaMain.css';
import TeX from '@matejmazur/react-katex';
import MathJax from 'react-mathjax-preview';
import * as BiIcons from "react-icons/bi";
import {useHistory} from "react-router-dom";

export default function CiagiNiesk(){

    useEffect(()=>{
        document.title="Ciągi nieskończone";
    },[])

    const { push } = useHistory();

    const comeBackFunc=()=>{
        push('/analiza/pojecia-wstepne');
    }

    return(
      <div className='conceptsContainer'>
          <div className='comeBackDiv' onClick={comeBackFunc}>
              <BiIcons.BiArrowBack/>
              <div style={{textAlign: 'left', alignItems: 'left'}}>Cofnij</div>
          </div>

          <h1>Ciąg nieskończony</h1>
          <p>Ciąg nieskończony to ciąg, który nie ma określonego wyrazu ostatniego, znaczy to, że każdej liczbie naturalnej
          &nbsp;<TeX math={'n'}/>&nbsp; odpowiada wyraz tego ciągu.</p>
          <br/>
          <p>Ciąg nieskończony ma granicę <TeX math={'g'}/>, jeżeli dla każdej liczby dodatniej ϵ istnieje w ciągu takie miejsce N,
              że dla każdego <TeX math={'n'}/>&#8805;N zachodzi nierówność:</p>
          <p>|<TeX math={'a_n-g'}/>|&#60;ϵ</p>
          <p>Zapis, że ciąg dąży do granicy <TeX math={'g'}/> wygląda następująco:</p>
          <p className='oneLine centerVertical'><MathJax math={'`u_n to g`'}/>, gdy
              &nbsp;<MathJax math={'`n to infty`'}/> &nbsp;&nbsp; lub &nbsp;&nbsp;
              <MathJax math={'`lim_(n to infty)u_n=infty`'}/>
          </p>
          <br/><br/>

          <p>Ciąg nieskończony, który ma granicę skończoną nazywamy ciągiem zbieżnym.</p>
          <p>Jeżeli ciąg nie ma granicy skończonej to nazywamy go ciągiem rozbieżnym. Stosujemy tutaj pojęcie dolnej i górnej granicy,
          które są odpowiednio najmniejszą i największą granicą danego ciągu.</p>
          <br/>

          <p>Ciąg dąży do plus nieskończoności, jeżeli dla każdej liczby <TeX math={'z'}/>&#62;0 można znaleźć w ciągu taki wyraz
              na pozycji <TeX math={'n'}/>, dla którego <TeX math={'u_n'}/>&#62;<TeX math={'z'}/></p>

          <p>Ciąg dąży do minus nieskończoności, jeżeli dla każdej liczby <TeX math={'z'}/>&#60;0 można znaleźć w ciągu taki wyraz na
              pozycji <TeX math={'n'}/>, dla którego <TeX math={'u_n'}/>&#60;<TeX math={'z'}/></p>
          <br/>
          <p>Mamy jednak wyjątki, ponieważ nie każdy ciąg nieskończony ma granicę. Np. ciąg 1, 2, 3, 4, 5, 1, 2, 3, 4, 5, 1, 2, ...
              nie ma granicy.</p>
          <br/><br/><br/>

          <h3>Własności:</h3>
          <p>1)&nbsp;&nbsp;Jeżeli ciąg <TeX math={'a_n'}/> ma granicę a i ciąg <TeX math={'b_n'}/> ma granicę b to ciąg
              &#123;<TeX math={'a_n'}/> + <TeX math={'b_n'}/>&#125; ma granicę a+b.
          </p>

          <p>2)&nbsp;&nbsp;Jeżeli ciąg <TeX math={'a_n'}/> ma granicę <TeX math={'a'}/>
              i ciąg <TeX math={'b_n'}/> ma granicę<TeX math={'b'}/> oraz żaden z wyrazów ciągu <TeX math={'b_n'}/> nie równa
              się 0 i granica <TeX math={'b'}/> nie równa się 0 to ciąg ilorazów <TeX math={'a_n/b_n'}/> ma granicę <TeX math={'a/b'}/>.
          </p>

          <p>3)&nbsp;&nbsp;Jeżeli licznik ułamka jest wielomianem względem zmiennej naturalnej <TeX math={'n'}/>, której stopień jest
              wyższy niż stopnień mianownika, to gdy <MathJax math={'`n to infty,`'}/>wartość ułamka dąży do plus/minus nieskończoności.
          </p>

          <p className='oneLine centerVertical'>
              <MathJax math={'`lim_(n to infty)(1+1/n)^n=e`'}/>, gdzie n jest dowolnym wyrazem ciągu &nbsp;<TeX math={'a_n'}/>
              (<TeX math={'n'}/>&#8800;0),&nbsp;&nbsp;<TeX math={'e'}/> - liczba Eulera (2,71828...).
          </p>

          <br/><br/><br/>
      </div>
    );
}